export const copyUrlToClipboard = (path?: string) =>
  window.navigator.clipboard.writeText(window.origin + path);
